import React from 'react';
import APARTMENT from '../../assets/estates/APARTMENT.svg';
import DETACHED_HOUSE from '../../assets/estates/DETACHED_HOUSE.svg';
import END_TERRACE_HOUSE from '../../assets/estates/END_TERRACE_HOUSE.svg';
import MID_TERRACE_HOUSE from '../../assets/estates/MID_TERRACE_HOUSE.svg';
import PROPERTY from '../../assets/estates/PROPERTY.svg';
import RESIDENTIAL_AND_COMMERCIAL_BUILDING from '../../assets/estates/RESIDENTIAL_AND_COMMERCIAL_BUILDING.svg';
import SEMI_DETACHED_HOUSE from '../../assets/estates/SEMI_DETACHED_HOUSE.svg';
import TWO_FAMILY_HOUSE from '../../assets/estates/TWO_FAMILY_HOUSE.svg';
import { Circular } from "../circular/Circular.js";
import styles from "./EstateImage.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function EstateImage({
  type,
  ...props
}) {
  const iconUrl = {
    APARTMENT,
    APARTMENT_BUILDING: APARTMENT,
    PROPERTY,
    DETACHED_HOUSE,
    END_TERRACE_HOUSE,
    MID_TERRACE_HOUSE,
    RESIDENTIAL_AND_COMMERCIAL_BUILDING,
    SEMI_DETACHED_HOUSE,
    TWO_FAMILY_HOUSE
  }[type] || DETACHED_HOUSE;
  return /*#__PURE__*/_jsx(Circular, {
    ...props,
    centered: true,
    children: /*#__PURE__*/_jsxs("svg", {
      className: styles.svg,
      viewBox: "0 0 48 48",
      children: [/*#__PURE__*/_jsx("title", {
        children: type
      }), /*#__PURE__*/_jsx("use", {
        xlinkHref: `${iconUrl}#ESTATE_IMAGE`,
        href: `${iconUrl}#ESTATE_IMAGE`
      })]
    })
  });
}